var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":_vm.bgImg,"alt":""},on:{"click":function($event){$event.stopPropagation();return _vm.downLoad($event)}}}),_vm._v(" "),(_vm.isShow)?_c('div',{staticClass:"wechat-tips",staticStyle:{"display":"block"}},[_c('img',{attrs:{"src":_vm.imgTip,"alt":""}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-586e7a36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/mobilPage/marketing.vue
// module id = null
// module chunks = 